import { createContext, ReactNode } from "react";

type WidgetFrameTitleContextProps = {
    title: ReactNode | null;
};

export const WidgetFrameTitleContext = createContext<WidgetFrameTitleContextProps>({
    title: null,
});
